import { FormEvent, useState } from 'react'
import { authAdapter } from '../../adapters/auth/supabaseAuthAdapter'

export function LoginView() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await authAdapter.signInWithEmail(email, password)
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Accesso non riuscito')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <div className="brand-mark">EP</div>
        <p className="eyebrow">EVENT PLATFORM</p>
        <h1>Accedi alla piattaforma</h1>
        <p className="muted">Un unico motore per organizzazioni, eventi e moduli operativi.</p>

        <form onSubmit={handleSubmit}>
          <label>Email
            <input type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </label>
          <label>Password
            <input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required />
          </label>
          {error && <div className="alert">{error}</div>}
          <button className="primary" disabled={busy}>{busy ? 'Accesso…' : 'Entra'}</button>
        </form>
      </section>
    </main>
  )
}
